import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import PruTable from '../../../../../../common/components/PruTable/PruTable';
import { useHistory } from 'react-router-dom';
import { getDefaultDisplayDate } from '../../../../../../common/utils/time-utils';
import { PARAMETER_PATH, SIMULATION_TOOL_PATH } from 'src/app/modules/SimulationTool/constants';
import { ParameterPaginateList } from 'src/app/modules/SimulationTool/types/parameter-setting';

type ParameterSettingListProps = {
  isLoading: boolean;
  parameterList?: ParameterPaginateList;
  onRefresh: () => void;
  onChangePage: (page: number, rowsPerPage: number) => void;
  onSort: (sortingState: { key: string; value?: string }) => void;
};

const ParameterSettingList: FC<ParameterSettingListProps> = ({
  isLoading,
  onRefresh,
  onChangePage,
  parameterList,
  onSort,
}) => {
  const history = useHistory();
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });

  return (
    <PruTable
      disableBulkSelect
      dataSource={parameterList?.items}
      isLoading={isLoading}
      onRefresh={onRefresh}
      title={Translation('parameterSetting.list')}
      operationDef={[
        {
          title: Translation('section.common.operation.edit'),
          tooltipText: 'Edit Parameter',
          onClick: (row) => history.push(`${SIMULATION_TOOL_PATH}${PARAMETER_PATH}/edit/${row._id}`),
        },
      ]}
      columnDef={[
        {
          isId: true,
          hidden: true,
          keyIndex: '_id',
          displayName: '',
          renderData: () => '',
        },
        {
          keyIndex: 'code',
          displayName: Translation('parameterSetting.code'),
          renderData: (row) => row.code,
        },
        {
          keyIndex: 'name',
          displayName: Translation('parameterSetting.name'),
          renderData: (row) => row.name,
        },
        {
          keyIndex: 'type',
          align: 'center',
          displayName: Translation('parameterSetting.type'),
          renderData: (row) => row.type,
        },
        {
          keyIndex: 'updatedBy',
          displayName: Translation('parameterSetting.lastUpdatedBy'),
          renderData: (row) => row.updatedBy,
        },
        {
          keyIndex: 'updatedAt',
          align: 'center',
          displayName: Translation('parameterSetting.lastUpdatedAt'),
          renderData: (row) => getDefaultDisplayDate(row.updatedAt),
          sortable: true,
          onSort: (sort) => {
            onSort({
              key: 'lastUpdateDateSort',
              value: sort['updatedAt'],
            });
          },
        },
      ]}
      totalPages={parameterList?.totalPages}
      totalRecords={parameterList?.totalRecords}
      onChangePage={onChangePage}
    />
  );
};

export default ParameterSettingList;
